import RoomPageBase from './room-page-base'
import stimulus from 'lib/stimulus-instance'
import GlideSliderController from 'frontend/controllers/glide-slider-controller'
import React from 'react'
import ReactDOM from 'react-dom'
import moment from 'lib/moment-timezone-custom'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import ScheduleComponent from 'frontend/pages/rooms/hhla-schedule-base'

stimulus.register('glide-slider', GlideSliderController)

export default class HhlaPageBase extends RoomPageBase {
  static async initVideo () {
    if (this.videoInitialized) return

    document.querySelectorAll('.video-reviews .video_container').forEach(el => clickToPlayWrap(el))
    this.videoInitialized = true
  }

  static async mountRoomSchedule () {
    if (this.roomScheduleMounted || !this.scheduleRoot) return

    this.roomScheduleMounted = true

    ReactDOM.render(
      React.createElement(
        ScheduleComponent,
        {
          roomId: parseInt(this.props.roomId),
          openedFrom: moment(this.props.openedFrom),
          prebookingCodeOnly: this.props.prebookingCodeOnly !== undefined,
        },
      ),
      this.scheduleRoot,
    )
  }

  static handleStylesApplied () {
    this.onEnter('.video_container', this.initVideo.bind(this))
    this.mountRoomSchedule()
  }

  static get props () {
    return document.body.dataset
  }
}
